import React from 'react';

const ImageZoomModal = ({ zoomImageUrl, setZoomImageUrl }) => {
  if (!zoomImageUrl) return null;

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.85)",
        zIndex: 1050,
      }}
      onClick={() => setZoomImageUrl(null)}
    >
      <div
        className="position-relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="btn-close btn-close-white position-absolute end-0 top-0"
          style={{ zIndex: 1060, margin: "10px" }}
          onClick={() => setZoomImageUrl(null)}
        ></button>
        <img
          src={zoomImageUrl}
          alt="Zoomed"
          className="img-fluid rounded shadow"
          style={{
            maxHeight: "90vh",
            maxWidth: "95vw",
            objectFit: "contain",
            border: "6px solid white",
          }}
        />
      </div>
    </div>
  );
};

export default ImageZoomModal; 